<template>
    <div>
        <span
            class="recipes-filter--toggle"
            v-if="showFilterbutton"
            v-bind:class="{ active: isActive }"
            @click="toggleFilter()"
        >
            <span class="recipes-filter--show">Visa filter</span>
            <span class="recipes-filter--hide">Dölj filter</span>
        </span>
        <form id="recipes-filter" class="recipes-filter col-sm-4 col-md-3" v-if="isActive">
            <span class="filter--active" v-if="activeFiltersCount"
                >Aktiva filter: <strong>{{ activeFiltersCount }}</strong></span
            >
            <span class="filter--inactive" v-else="activeFiltersCount">Inga aktiva filter</span>
            <span class="filter--reset" v-if="activeFiltersCount" @click="resetFilter">Återställ filter</span>

            <section class="filter--authors filter">
                <strong class="filter--title">Recept av</strong>
                <ul class="filter--options">
                    <li class="filter--option">
                        <label>
                            <input
                                type="checkbox"
                                name="authors[]"
                                value="admin"
                                v-model="checkedAuthors"
                                @change="filter"
                            />
                            <span>Matdagboken</span>
                        </label>
                    </li>
                    <li class="filter--option">
                        <label>
                            <input
                                type="checkbox"
                                name="authors[]"
                                value="members"
                                v-model="checkedAuthors"
                                @change="filter"
                            />
                            <span>Medlemmar</span>
                        </label>
                    </li>
                </ul>
            </section>

            <section class="filter--tags filter">
                <strong class="filter--title">Kost</strong>
                <ul class="filter--options">
                    <li class="filter--option" v-for="tag in tags">
                        <label>
                            <input
                                type="checkbox"
                                :id="tag.id"
                                :value="tag.id"
                                name="tags[]"
                                v-model="checkedTags"
                                @change="filter"
                            />
                            <span>{{ tag.title }}</span>
                        </label>
                    </li>
                </ul>
            </section>

            <section class="filter--categories filter" v-for="parent in parents">
                <strong class="filter--title">{{ parent.text }}</strong>
                <ul class="filter--options">
                    <li class="filter--option" v-for="child in getChildren(parent.id)">
                        <label>
                            <input
                                type="checkbox"
                                name="categories[]"
                                :value="child.id"
                                v-model="checkedCategories"
                                @change="filter"
                            />
                            <span>{{ child.text }}</span>
                        </label>
                    </li>
                </ul>
            </section>

            <section class="filter--kcal filter">
                <div class="filter--title">
                    <strong>Kalorier <span>per portion</span></strong>
                </div>
                <div class="filter--options">
                    <multi-range-slider
                        ref="slider-fat"
                        :baseClassName="'multi-range-slider-bar-only'"
                        :value="rangeValue.kcal"
                        :min="0"
                        :max="kcalDefaultValue"
                        :minValue="parseInt(rangeValue.kcal[0])"
                        :step="1"
                        :maxValue="parseInt(rangeValue.kcal[1])"
                        @input="updateRangeValues($event, 'kcal')"
                    />
                    <span>{{ rangeValue.kcal[0] }} kcal</span>
                    <span>{{ rangeValue.kcal[1] }} kcal</span>
                    <input type="hidden" name="kcal[]" v-model="rangeValue.kcal" />
                </div>
            </section>

            <section class="filter--fat filter">
                <div class="filter--title">
                    <strong>Fett <span>per portion</span></strong>
                </div>
                <div class="filter--options">
                    <multi-range-slider
                        ref="slider-fat"
                        :baseClassName="'multi-range-slider-bar-only'"
                        :value="rangeValue.fat"
                        :min="0"
                        :max="fatDefaultValue"
                        :minValue="parseInt(rangeValue.fat[0])"
                        :step="1"
                        :maxValue="parseInt(rangeValue.fat[1])"
                        @input="updateRangeValues($event, 'fat')"
                    />

                    <span>{{ rangeValue.fat[0] }} g</span>
                    <span>{{ rangeValue.fat[1] }} g</span>
                    <input type="hidden" name="fat[]" v-model="rangeValue.fat" />
                </div>
            </section>

            <section class="filter--protein filter">
                <div class="filter--title">
                    <strong>Protein <span>per portion</span></strong>
                </div>
                <div class="filter--options">
                    <multi-range-slider
                        ref="slider-protein"
                        :baseClassName="'multi-range-slider-bar-only'"
                        :value="rangeValue.protein"
                        :min="0"
                        :max="proteinDefaultValue"
                        :minValue="parseInt(rangeValue.protein[0])"
                        :step="1"
                        :maxValue="parseInt(rangeValue.protein[1])"
                        @input="updateRangeValues($event, 'protein')"
                    />

                    <span>{{ rangeValue.protein[0] }} g</span>
                    <span>{{ rangeValue.protein[1] }} g</span>
                    <input type="hidden" name="protein[]" v-model="rangeValue.protein" />
                </div>
            </section>

            <section class="filter--carbohydrates filter">
                <div class="filter--title">
                    <strong>Kolhydrater <span>per portion</span></strong>
                </div>
                <div class="filter--options">
                    <multi-range-slider
                        ref="slider-carbohydrates"
                        :baseClassName="'multi-range-slider-bar-only'"
                        :value="rangeValue.carbohydrates"
                        :min="0"
                        :max="carbohydratesDefaultValue"
                        :minValue="parseInt(rangeValue.carbohydrates[0])"
                        :step="1"
                        :maxValue="parseInt(rangeValue.carbohydrates[1])"
                        @input="updateRangeValues($event, 'carbohydrates')"
                    />

                    <span>{{ rangeValue.carbohydrates[0] }} g</span>
                    <span>{{ rangeValue.carbohydrates[1] }} g</span>
                    <input type="hidden" name="carbohydrates[]" v-model="rangeValue.carbohydrates" />
                </div>
            </section>

            <section class="filter--stars filter">
                <strong class="filter--title">Betyg</strong>
                <ul class="filter--options">
                    <li v-for="rating in ratings" class="filter--option">
                        <label>
                            <input
                                type="checkbox"
                                name="ratings[]"
                                :value="rating"
                                v-model="checkedRatings"
                                @change="filter"
                            />
                            <span v-if="rating === 1">{{ rating }} stjärna</span>
                            <span v-else>{{ rating }} stjärnor</span>
                        </label>
                    </li>
                </ul>
            </section>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

import state from '../state.js';

import MultiRangeSlider from 'multi-range-slider-vue';

import { mapAndPushHistory, getValueFromUrlOnLoad } from './../utils/helpers.js';

export default {
    components: {
        MultiRangeSlider
    },

    data() {
        return {
            state,
            tags: [],
            children: [],
            parents: [],
            checkedTags: [],
            checkedCategories: [],
            checkedRatings: [],
            checkedAuthors: [],
            isActive: false,
            showFilterbutton: false,
            ratings: [1, 2, 3, 4, 5],
            kcalDefaultValue: 2000,
            fatDefaultValue: 200,
            proteinDefaultValue: 200,
            carbohydratesDefaultValue: 200,
            rangeValue: {
                kcal: [0, 2000],
                fat: [0, 200],
                protein: [0, 200],
                carbohydrates: [0, 200]
            },

            mapAndPushHistory,
            getValueFromUrlOnLoad
        };
    },

    mounted() {
        this.getCategories();
        this.getTags();
        this.setFilterVisibility(this.$parent.isScreenBelow768);
    },

    computed: {
        filterState: function () {
            return this.state.filter;
        },

        activeFiltersCount: function () {
            let kcal =
                this.rangeValue.kcal[0] != 0 || this.rangeValue.kcal[1] != this.kcalDefaultValue ? 1 : 0;
            let fat = this.rangeValue.fat[0] != 0 || this.rangeValue.fat[1] != this.fatDefaultValue ? 1 : 0;
            let protein =
                this.rangeValue.protein[0] != 0 || this.rangeValue.protein[1] != this.proteinDefaultValue
                    ? 1
                    : 0;
            let carbohydrates =
                this.rangeValue.carbohydrates[0] != 0 ||
                this.rangeValue.carbohydrates[1] != this.carbohydratesDefaultValue
                    ? 1
                    : 0;

            return (
                this.checkedTags.length +
                this.checkedCategories.length +
                this.checkedRatings.length +
                kcal +
                fat +
                protein +
                carbohydrates
            );
        }
    },

    watch: {
        '$parent.isScreenBelow768': function (newVal) {
            this.setFilterVisibility(newVal);
        },

        filterState(filter) {
            this.checkedTags = filter.tags ? filter.tags : [];
            this.checkedCategories = filter.categories ? filter.categories : [];
            this.checkedRatings = filter.ratings ? filter.ratings : [];
            this.checkedAuthors = filter.authors ? filter.authors : [];
            this.rangeValue.kcal = filter.kcal ? filter.kcal : [0, this.kcalDefaultValue];
            this.rangeValue.fat = filter.fat ? filter.fat : [0, this.fatDefaultValue];
            this.rangeValue.protein = filter.protein ? filter.protein : [0, this.proteinDefaultValue];
            this.rangeValue.carbohydrates = filter.carbohydrates
                ? filter.carbohydrates
                : [0, this.carbohydratesDefaultValue];
        },

        activeFiltersCount() {
            if (this.activeFiltersCount > 1) {
                $('.recipes--search-result').remove();
            }
        }
    },

    methods: {
        setFilterVisibility(isScreenBelow768) {
            if (isScreenBelow768) {
                this.showFilterbutton = true;
                this.isActive = false;
            } else {
                this.showFilterbutton = false;
                this.isActive = true;
            }
        },

        updateRangeValues(e, type) {
            const values = getValueFromUrlOnLoad(type);

            if (values && e.minValue === 0) {
                this.rangeValue[type] = [values[0], values[1]];
            } else {
                this.rangeValue[type] = [e.minValue, e.maxValue];
            }

            mapAndPushHistory(type, e);
        },

        filter() {
            mapAndPushHistory();
        },

        toggleFilter() {
            this.isActive = !this.isActive;
        },

        resetFilter() {
            this.checkedTags = [];
            this.checkedCategories = [];
            this.checkedRatings = [];
            this.checkedAuthors = [];
            this.rangeValue.kcal = [0, this.kcalDefaultValue];
            this.rangeValue.fat = [0, this.fatDefaultValue];
            this.rangeValue.protein = [0, this.proteinDefaultValue];
            this.rangeValue.carbohydrates = [0, this.carbohydratesDefaultValue];

            if ($('.recipes--search-result').length) {
                $('.recipes--search-result').remove();
            }

            // this.state.recipeQueryString = 'search=';

            mapAndPushHistory('reset');
        },

        getCategories() {
            axios.get('/recept/api/categories/filter').then((response) => {
                response.data.forEach((category) => {
                    if (category.depth == 1) {
                        this.parents.push(category);
                    } else if (category.depth == 2) {
                        this.children.push(category);
                    }
                });
            });
        },

        getChildren(parentId) {
            return this.children.filter((child) => child.parent === parentId);
        },

        getTags() {
            axios.get('/recept/api/tags').then((response) => {
                this.tags = response.data;
            });
        }
    }
};
</script>
